import AcUnitOutlinedIcon from '@material-ui/icons/AcUnitOutlined'

export const TopIcon = [
    { icon: AcUnitOutlinedIcon },
    // {icon:Img}, in case if the icon is png/svg format,instead of MUI icons
]